import React, { useState } from 'react';

const DateSelector = ({ onDateRangeChange, currentRange }) => {
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');

  // Get current date for default values
  const getCurrentDate = () => {
    return new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
  };

  // Get first day of current month
  const getCurrentMonthStart = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
  };

  // Quick date presets
  const quickPresets = [
    {
      label: 'Current Month',
      getRange: () => ({
        start_date: getCurrentMonthStart(),
        end_date: getCurrentDate()
      })
    },
    {
      label: 'Last 7 Days',
      getRange: () => {
        const end = new Date();
        const start = new Date(end.getTime() - 7 * 24 * 60 * 60 * 1000);
        return {
          start_date: start.toISOString().split('T')[0],
          end_date: end.toISOString().split('T')[0]
        };
      }
    },
    {
      label: 'Last 30 Days',
      getRange: () => {
        const end = new Date();
        const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000);
        return {
          start_date: start.toISOString().split('T')[0],
          end_date: end.toISOString().split('T')[0]
        };
      }
    },
    {
      label: 'This Year',
      getRange: () => {
        const now = new Date();
        return {
          start_date: new Date(now.getFullYear(), 0, 1).toISOString().split('T')[0],
          end_date: getCurrentDate()
        };
      }
    }
  ];

  // Handle quick preset selection
  const handlePresetClick = (preset) => {
    const range = preset.getRange();
    onDateRangeChange(range);
  };

  // Handle custom date range
  const handleCustomRange = () => {
    if (customStart && customEnd) {
      if (customStart > customEnd) {
        alert('Start date must be before end date');
        return;
      }
      onDateRangeChange({
        start_date: customStart,
        end_date: customEnd
      });
    } else {
      alert('Please select both start and end dates');
    }
  };

  // Clear date range (use default)
  const handleClearRange = () => {
    setCustomStart('');
    setCustomEnd('');
    onDateRangeChange({
      start_date: null,
      end_date: null
    });
  };

  // Format current range display
  const getCurrentRangeDisplay = () => {
    if (!currentRange.start_date && !currentRange.end_date) {
      return 'Current Month (Default)';
    }
    
    const start = currentRange.start_date || 'No start';
    const end = currentRange.end_date || 'No end';
    
    if (start === 'No start' && end === 'No end') {
      return 'Current Month (Default)';
    }
    
    return `${start} to ${end}`;
  };

  return (
    <div className="date-selector">
      <div className="date-selector-header">
        <h3>Date Range: {getCurrentRangeDisplay()}</h3>
      </div>
      
      <div className="quick-presets">
        <h4>Quick Select:</h4>
        <div className="preset-buttons">
          {quickPresets.map((preset, index) => (
            <button
              key={index}
              className="preset-button"
              onClick={() => handlePresetClick(preset)}
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>

      <div className="custom-range">
        <h4>Custom Range:</h4>
        <div className="custom-date-inputs">
          <div className="date-input-group">
            <label htmlFor="start-date">Start Date:</label>
            <input
              id="start-date"
              type="date"
              value={customStart}
              onChange={(e) => setCustomStart(e.target.value)}
              max={getCurrentDate()}
            />
          </div>
          <div className="date-input-group">
            <label htmlFor="end-date">End Date:</label>
            <input
              id="end-date"
              type="date"
              value={customEnd}
              onChange={(e) => setCustomEnd(e.target.value)}
              max={getCurrentDate()}
              min={customStart}
            />
          </div>
          <div className="custom-range-actions">
            <button 
              className="apply-button" 
              onClick={handleCustomRange}
              disabled={!customStart || !customEnd}
            >
              Apply Range
            </button>
            <button className="clear-button" onClick={handleClearRange}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateSelector;
